export default {
  appLocaleKey: 'appLocaleAndLabels',
  appKeyValuesStoreKey: 'appKeyValues',
  emailRegex:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phoneNumberRegex: /^(?!(\d)\1+$)(?:\(?\+\d{1,3}\)?[- ]?|0)?\d{10}$/,
  colorHexCodeRegex: /^#[0-9A-F]{6}$/i,
  readOnlyUserGroupTypes: ['S_ORG_UNIT_MEMBER'],
  staffId: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  genderRegex: /^[\u0621-\u064Aa-zA-Z]+$/, // For Both Arabic and English input
  alphaRegex: '[a-zA-Z ]*',
  noSpaceStart: /^(?!\s+$)[^\d]+$/,
  max500Char: 500,
  max250Char: 250,
  max1000Char: 1000,
  maxSize: 2147483647,
  onlyNumbers: /^\d+$/,
  numbers: /^[0-9]+$/,
};
